// src/Pages/Portfolio/PortfolioAux.js

// ===== Portfolio thresholds =====
export const portfolioThreshold = {
  "Less than 5K USD / 7K CAD": 1,
  "5K USD / 7K CAD": 2,
  "10K USD / 14K CAD": 3,
  "25K USD / 35K CAD": 4,
  "50K USD / 70K CAD": 5,
  "100K USD / 140K CAD": 6,
  "250K USD / 350K CAD": 7,
  "500K USD / 700K CAD": 8,
  "1M USD / 1.4M CAD": 9,
  "2.5M USD / 3.5M CAD": 10,
  "5M USD / 7M CAD": 11,
  "10M USD / 14M CAD": 12,
  "25M USD / 35M CAD": 13,
  "50M USD / 70M CAD": 14,
  "100M USD / 140M CAD": 15,
  "250M USD / 350M CAD": 16,
  "500M USD / 700M CAD": 17,
  "1B USD / 1.4B CAD": 18
};

// ===== Portfolio access rules =====
export const portfolioAccessRules = {
  none: 8,
  select: 9,
  plus: 10,
  pro: 11,
  proplus: 12,
  elite: 13,
  eliteplus: 14,
  premier: 15,
  premierplus: 16,
  signature: 17,
  billion: 18
};

// ===== Tier labels =====
export const tierDisplayLabel = {
  none: "No Club tier",
  select: "Select",
  plus: "Plus",
  pro: "Pro",
  proplus: "Pro Plus",
  elite: "Elite",
  eliteplus: "Elite Plus",
  premier: "Premier",
  premierplus: "Premier Plus",
  signature: "Signature",
  billion: "Billion Club"
};

// ===== Human → key =====
export const humanToKey = {
  "No Club tier": "none",
  "Select": "select",
  "Plus": "plus",
  "Pro": "pro",
  "Pro Plus": "proplus",
  "Elite": "elite",
  "Elite Plus": "eliteplus",
  "Premier": "premier",
  "Premier Plus": "premierplus",
  "Signature": "signature",
  "Billion Club": "billion"
};

// ===== Normalize tier =====
export function normalizeClubTier(clubTier) {
  if (!clubTier) return "none";

  const str = String(clubTier).trim();

  if (humanToKey[str]) return humanToKey[str];

  return str
    .replace("club_", "")
    .replace("_usd_month", "")
    .replace("_usd_year", "")
    .replace("_cad_month", "")
    .replace("_cad_year", "")
    .replace(/_/g, "");
}

// ===== Portfolio fetch helper (SAFE MOVE) =====
export async function handleSelectionChange({
  portfolioLabel,
  portfolioType,
  API_ENDPOINT,
  CONSERVATIVE_DIFFERENT_FROM_LEVEL,
  setPortfolioData,
  setSelectedPortfolio,
  setPortfolioLoading
}) {
  setPortfolioData([]);
  setSelectedPortfolio(portfolioLabel);

  if (!portfolioLabel) return;

  const uid = localStorage.getItem("userUid");
  if (!uid) {
    console.warn("No uid in localStorage, cannot fetch portfolio.");
    return;
  }

  try {
    setPortfolioLoading(true);

    const requestedLevel = portfolioThreshold[portfolioLabel];

    const shouldUseConservative =
      portfolioType === "conservative" &&
      requestedLevel >= CONSERVATIVE_DIFFERENT_FROM_LEVEL;

    const endpoint = shouldUseConservative
      ? "get-conservative-portfolio-by-tier"
      : "get-portfolio-by-tier";

    const res = await fetch(`${API_ENDPOINT}${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ uid, portfolioLabel })
    });

    const data = await res.json();

    if (!res.ok || data.status !== "succeed") {
      console.warn("get-portfolio-by-tier failed:", data);
      setPortfolioData([]);
      return;
    }

    const list = Array.isArray(data.items) ? data.items : [];
    setPortfolioData(list);

  } catch (error) {
    console.error("Error fetching portfolio data:", error);
    setPortfolioData([]);
  } finally {
    setPortfolioLoading(false);
  }
}
